import React from 'react';

import { faEdit } from '@fortawesome/pro-regular-svg-icons';
import { useIntl } from 'react-intl';

import { AllowListItem } from 'src/features/allowList/utils/types';
import { allowListMessages } from 'src/features/allowList/utils/allowListMessages';
import { toast } from 'src/hooks/UseToast';
import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import AllowListItemFormModal from 'src/features/allowListItem/components/forms/AllowListItemFormModal';
import { useUpdateAllowListItem } from 'src/features/allowListItem/api/useUpdateAllowListItem';
import { LIST_ALLOW_LIST_ITEMS_RESOURCE } from 'src/features/allowListItem/api/useListAllowListItems';
import { useParams } from 'react-router-dom';
import { useParking } from 'src/providers/ParkingProvider';

interface AllowListItemFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    selectedAllowListItem: AllowListItem;
    children?: React.ReactNode;
}

export default function UpdateAllowListItemFormModal<TData>({ className, semantics, children, selectedAllowListItem }: AllowListItemFormModalProps<TData>) {
    const { formatMessage } = useIntl();
    const { listId = '' } = useParams();
    const { parkingId } = useParking()
    const { mutate, isPending } = useUpdateAllowListItem({
        onSuccess: (success) => {
            void queryClient.invalidateQueries({ queryKey: [LIST_ALLOW_LIST_ITEMS_RESOURCE] });
            toast({
                title: formatMessage(allowListMessages.updateAllowListItemSuccess),
                description: formatMessage(allowListMessages.updateAllowListItemSuccessDescription, {
                    entry: success.name,
                }),
            });
        },
    });

    return (
        <AllowListItemFormModal
            selectedAllowListItem={selectedAllowListItem}
            className={className}
            mutate={(data, onSuccess, onError) => mutate({ parkingId, data, listId, itemId: selectedAllowListItem.id }, { onSuccess, onError })}
            title={formatMessage(generalMessages.editEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={faEdit}
            isPending={isPending}
            subtitle={formatMessage(allowListMessages.editAllowListItemSubtitle, {
                entry: selectedAllowListItem.name,
            })}
            listId={listId}
        >
            {children}
        </AllowListItemFormModal>
    );
}
